






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import GalleryCategorys from "@/components/tables/gallery/gallery-categorys.vue";
import GalleryForm from "@/components/forms/gallery/gallery-form.vue";
import GalleryCategoryForm from "@/components/forms/gallery/gallery-category-form.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { ICategory, IGallery } from "@/@types/gallsery/gallery";

@Component({
  components: {
    StandartModal,
    GalleryCategoryForm,
    GalleryCategorys,
    ButtonBack,
    GalleryForm,
  },
})
export default class GalleryFTP extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Array, default: () => [] }) gallerys!: Array<IGallery>;
  @Prop({ type: Array, default: () => [] }) formats!: Array<IGallery>;
  @Prop({ type: String, default: "" }) activeCategory!: string;

  tabIndex = 0;

  gallery: IGallery | null = null;
  folder: ICategory | null = null;

  hide(): void {
    this.gallery = null;
    this.folder = null;
  }

  quickChange(item: IGallery | ICategory, type: string): void {
    if (type == "gallery") this.$emit("updateGallery", item);
    else this.$emit("updateFolder", item);
    this.gallery = null;
    this.folder = null;
  }

  deleteFolder(id: string, type: string): void {
    if (type == "gallery") {
      this.$emit("dropGallery", id);
      return;
    }
    this.$emit("dropFolder", id);
  }

  changed(id: string, type: string): void {
    this.$bvModal.show("bv-modal-add");
    if (type == "gallery") {
      const g = this.gallerys.find((el: IGallery) => el._id == id);
      this.gallery = g ? g : null;
      return;
    }
    const f = this.categorys.find((el: ICategory) => el._id == id);
    this.folder = f ? f : null;
  }
}
